// The first-run tour: cards by role, shown once (kept on the phone and on the user record),
// skippable, replayable from Settings.
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../auth';
import { Icon } from './Icon';
import { TOURS, TOUR_VERSION, tourGroup } from './tourCards';

const key = (uid: string) => `tv.tour.v${TOUR_VERSION}.${uid}`;
export function tourSeen(uid: string): boolean { try { return !!localStorage.getItem(key(uid)); } catch { return false; } }
export function markTourSeen(uid: string, paths: { users: string }) { try { localStorage.setItem(key(uid), new Date().toISOString()); } catch { /* fine */ } void updateDoc(doc(db, `${paths.users}/${uid}`), { tourSeenAt: serverTimestamp(), tourVersion: TOUR_VERSION }).catch(() => {}); }
export function resetTour(uid: string) { try { localStorage.removeItem(key(uid)); } catch { /* fine */ } }

export function Tour({ force, onDone }: { force?: boolean; onDone?: () => void }) {
  const { session } = useAuth();
  const nav = useNavigate();
  const group = tourGroup(session?.role);
  const [i, setI] = useState(0);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!session || !group) return; if (force || !tourSeen(session.user.uid)) { setI(0); setOpen(true); } }, [session, group, force]);
  if (!session || !group || !open) return null;
  const cards = TOURS[group]; const c = cards[i]; const last = i === cards.length - 1;
  const finish = () => { markTourSeen(session.user.uid, { users: session.paths.users }); setOpen(false); onDone?.(); };
  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center md:justify-center" style={{ background: 'var(--scrim, rgba(0,0,0,.55))' }}>
      <div className="bg-surface w-full md:max-w-[480px] rounded-t-[22px] md:rounded-[18px] px-4 pt-3 pb-7 flex flex-col gap-3" style={{ paddingBottom: 'calc(28px + env(safe-area-inset-bottom, 0px))' }}>
        <div className="flex items-center justify-between"><span className="lbl">{i + 1} of {cards.length}</span><button className="text-muted font-head font-semibold text-[13px]" onClick={finish}>Skip</button></div>
        <div className="flex gap-1">{cards.map((_, k) => <span key={k} className={`h-1 flex-1 rounded ${k <= i ? 'bg-accent' : 'bg-line'}`} />)}</div>
        <h4 className="font-disp font-bold text-[26px] leading-none m-0">{c.title}</h4>
        <p className="m-0 text-[15px] leading-relaxed">{c.text}</p>
        <div className="flex gap-2 mt-1">
          {i > 0 && <button className="btn" onClick={() => setI(i - 1)}><Icon name="back" size={16} />Back</button>}
          {c.route && c.cta && <button className="btn" onClick={() => { finish(); nav(c.route!); }}>{c.cta}</button>}
          <button className="btn btn-primary flex-1" onClick={() => last ? finish() : setI(i + 1)}>{last ? 'Done' : 'Next'}{!last && <Icon name="chevron" size={16} />}</button>
        </div>
      </div>
    </div>
  );
}
